import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GrnFromPoForm } from "@/features/grns/GrnFromPoForm";

const search = z.object({ poId: z.string() });

export const Route = createFileRoute("/_authenticated/grns/new-from-po")({
  validateSearch: search,
  component: NewGrnFromPoPage,
});

function NewGrnFromPoPage() {
  const navigate = useNavigate();
  const { poId } = useSearch({ from: "/_authenticated/grns/new-from-po" });
  return (
    <div className="mx-auto max-w-7xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/purchase-orders/$poId", params: { poId } })}>
        <ArrowLeft className="mr-1 h-4 w-4" />Back to PO
      </Button>
      <GrnFromPoForm poId={poId} />
    </div>
  );
}
